export enum PinTypes {
    Member = 0,
    Ticket = 1,
    License = 2,
    CreditCard = 3,
    Invoice = 4
}

export interface IPinItem {
    ID: number;
    AdminID: number;
    Shared: boolean;
    PinType: PinTypes;
    RelationID: number;
    RelationInfo: string;
    RelationInfo1: string;
    DateTimeCreated: Date;
}

export class PinArray extends Array<PinItem>  {

    constructor(...items: PinItem[]) {
        super(...items);
        Object.setPrototypeOf(this, PinArray.prototype);
    }

}

export class PinItem implements IPinItem {
    ID: number;
    AdminID: number;
    Shared: boolean;
    PinType: PinTypes;
    RelationID: number;
    RelationInfo: string;
    RelationInfo1: string;
    DateTimeCreated: Date;

}
